import styled from 'styled-components'
import { css, media, fonts, colors, rgba, radiuses } from 'styles'
import UserThumbHorizontal from 'components/UserThumb/UserThumbHorizontal/StyledUserThumbHorizontal'
import UserThumb, { StyledStatusPanel } from 'components/UserThumb/StyledUserThumb'

const horizontalStyles = css`
  position: relative;
  .users {
    flex-flow: row wrap;
    width: 101%;
    margin: -0.5%;
  }
  ${UserThumb} {
    width: calc(100% / 6);
    padding: 0.5%;
    box-sizing: border-box;
  }
  .flirt-upgrade-message {
    display: flex;
    flex-flow: column wrap;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    background: ${rgba(colors.textMain, 0.3)};
    border-radius: ${radiuses.medium};
    text-align: center;
    .upgrade-message {
      max-width: 33rem;
      margin-top: 5rem;
      padding: 0rem 2rem 2rem;
      background: ${colors.highlight};
      border-radius: ${radiuses.medium};
      box-shadow: 0 0.2rem 1rem 0.2rem ${colors.textMain};
    }
    p {
      color: ${colors.mainInverted};
    }
  }

  .no-members {
    min-height: 20rem;
    font-weight: bold;
    text-align: center;
    font-size: 2.4rem;
  }
  ${media.mobile`
    min-height: auto;
    .users {
      justify-content: space-between;
      width: 100%;
      margin: 0;
    }
    ${UserThumb} {
      width: 32%;
    }
  `}

  ${media.phone`
    ${UserThumb} {
      width: 48%;
      &:hover{
        ${StyledStatusPanel}{
          display: none;
        }
      }
    }
  `}
`

const verticalStyles = css`
  .users {
    flex-flow: row wrap;
    max-width: 69rem;
    max-height: 24rem;
    overflow: hidden;

    ${UserThumbHorizontal} {
      margin-bottom: 2rem;
    }
  }

  ${media.mobile`
    .users {
      height: auto;
      flex-direction: row;
    }

    ${UserThumbHorizontal} {
      width: 100%;
      margin-right: 0;
      max-width: 85%;


      .avatar-img {
        width: 10rem;
        height: 10rem;
      }
    }
  `}
`

export const StyledUserList = styled.div`
  ${p => (p.vertical ? verticalStyles : horizontalStyles)}
  .users {
    display: flex;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
    color: ${p => (p.inverted ? colors.mainInverted : colors.textSectionTitle)};
    font: 700 1.8rem ${fonts.title};
    text-transform: uppercase;
  }
  ${media.mobile`
    font-size: 2.5rem;
  `}
`

export default StyledUserList
